import { render, staticRenderFns } from "./material-edit.vue?vue&type=template&id=8c2779da&scoped=true"
import script from "./material-edit.vue?vue&type=script&lang=js"
export * from "./material-edit.vue?vue&type=script&lang=js"
import style0 from "./material-edit.vue?vue&type=style&index=0&id=8c2779da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2779da",
  null
  
)

export default component.exports